/* ===========================================================================
   VJ-CORR-D174 — MES ENVIES
   6 septembre 2026
   ---------------------------------------------------------------------------
   Rachid : « avoir le petit cœur en haut à droite. »

   OÙ VIT LA LISTE. Dans `localStorage`, clé `vj-envies`, sous forme d'un
   tableau de poignées de produit. Rien ne part sur un serveur. Trois raisons :
   la boutique n'a pas de comptes clients ouverts, une liste d'envies qui
   exigerait une inscription ferait fuir le geste, et une poignée de produit
   n'est pas une donnée personnelle.

   CE QU'IL FAUT SAVOIR SUR `localStorage`. Il jette. Navigation privée,
   effacement des données, autre navigateur, autre appareil : la liste
   disparaît sans prévenir. Tout accès est donc enveloppé, et une lecture qui
   échoue rend une liste vide plutôt qu'une page cassée. Le cœur reste
   cliquable même quand rien ne peut être gardé — il ne ment pas, il ne promet
   simplement rien de plus que la session en cours.

   POURQUOI UN SEUL ÉCOUTEUR. Douze cartes au catalogue, quatre en « même
   esprit », cinq à l'accueil : autant de boutons. Un écouteur délégué sur le
   document les couvre tous, y compris ceux que wdt-filter.js injecte en AJAX
   après un filtre ou un changement de page — un écouteur par bouton ne
   survivrait pas au remplacement de la grille.

   Rollback : retirer la ligne de layout/theme.liquid et ce fichier. Les cœurs
   restent affichés mais inertes : retirer aussi le `render` de
   snippets/card-product.liquid.
   =========================================================================== */
(function () {
  'use strict';

  var CLE = 'vj-envies';

  function coffre() {
    try {
      var t = window.localStorage;
      t.setItem('vj-essai', '1');
      t.removeItem('vj-essai');
      return t;
    } catch (e) {
      return null; /* navigation privée, cookies refusés, quota */
    }
  }

  function lire() {
    var t = coffre();
    if (!t) return [];
    try {
      var l = JSON.parse(t.getItem(CLE) || '[]');
      return Object.prototype.toString.call(l) === '[object Array]' ? l : [];
    } catch (e) {
      return [];
    }
  }

  function ecrire(liste) {
    var t = coffre();
    if (!t) return;
    try {
      t.setItem(CLE, JSON.stringify(liste));
    } catch (e) {
      /* quota : la session en cours reste juste, la suivante repart à vide */
    }
  }

  function contient(piece) {
    return lire().indexOf(piece) !== -1;
  }

  function basculer(piece) {
    var l = lire();
    var i = l.indexOf(piece);
    if (i === -1) {
      l.push(piece);
    } else {
      l.splice(i, 1);
    }
    ecrire(l);
    return i === -1; /* vrai si on vient d'ajouter */
  }

  /* ── L'ÉTAT À L'ÉCRAN ─────────────────────────────────────────────────── */

  function peindre(bouton, actif) {
    bouton.setAttribute('aria-pressed', actif ? 'true' : 'false');
    bouton.classList.toggle('est-aime', actif);
    var libelle = actif
      ? bouton.getAttribute('data-vj-libelle-retrait')
      : bouton.getAttribute('data-vj-libelle-ajout');
    if (libelle) bouton.setAttribute('aria-label', libelle);
  }

  function peindreTout(racine) {
    var boutons = (racine || document).querySelectorAll('[data-vj-coeur]');
    var liste = lire();
    for (var i = 0; i < boutons.length; i++) {
      peindre(boutons[i], liste.indexOf(boutons[i].getAttribute('data-vj-piece')) !== -1);
    }
    annoncerCompte();
  }

  /* ── LE COMPTE, LÀ OÙ IL EST DEMANDÉ ──────────────────────────────────── */

  function annoncerCompte() {
    var n = lire().length;
    var porteurs = document.querySelectorAll('[data-vj-envies-compte]');
    for (var i = 0; i < porteurs.length; i++) porteurs[i].textContent = String(n);
    var bascules = document.querySelectorAll('[data-vj-envies-filtre]');
    for (var j = 0; j < bascules.length; j++) bascules[j].hidden = n === 0;
    document.documentElement.setAttribute('data-vj-envies', n > 0 ? '1' : '0');
  }

  /* ── LE FILTRE DU CATALOGUE ───────────────────────────────────────────────
     Purement visuel et purement client : on masque les cartes dont la poignée
     n'est pas dans la liste. Pas de requête, pas d'URL réécrite — ce filtre ne
     doit ni être partageable ni être indexé, puisqu'il ne veut rien dire pour
     quelqu'un d'autre. */

  function filtrer(actif) {
    var grille = document.getElementById('ProductGridContainer');
    if (!grille) return;
    var liste = lire();
    var cases = grille.querySelectorAll('li.product-loop, .product-grid > li');
    var vus = 0;
    for (var i = 0; i < cases.length; i++) {
      var coeur = cases[i].querySelector('[data-vj-coeur]');
      var piece = coeur ? coeur.getAttribute('data-vj-piece') : null;
      var garder = !actif || (piece && liste.indexOf(piece) !== -1);
      cases[i].hidden = !garder;
      if (garder) vus++;
    }
    grille.setAttribute('data-vj-envies-filtre-actif', actif ? '1' : '0');
    var vide = document.querySelector('[data-vj-envies-vide]');
    if (vide) vide.hidden = !(actif && vus === 0);
  }

  /* ── UN SEUL ÉCOUTEUR POUR TOUT ───────────────────────────────────────── */

  document.addEventListener('click', function (e) {
    var bascule = e.target.closest ? e.target.closest('[data-vj-envies-filtre]') : null;
    if (bascule) {
      e.preventDefault();
      var allume = bascule.getAttribute('aria-pressed') !== 'true';
      bascule.setAttribute('aria-pressed', allume ? 'true' : 'false');
      filtrer(allume);
      return;
    }

    var bouton = e.target.closest ? e.target.closest('[data-vj-coeur]') : null;
    if (!bouton) return;

    /* Le cœur est posé SUR l'image, qui est un lien. Sans ces deux lignes, le
       garder ouvrirait la fiche. */
    e.preventDefault();
    e.stopPropagation();

    var piece = bouton.getAttribute('data-vj-piece');
    if (!piece) return;
    var ajoute = basculer(piece);

    /* Tous les cœurs de la même pièce suivent : la fiche produit et la carte
       de « Dans le même esprit » peuvent être dans la même page. */
    var jumeaux = document.querySelectorAll('[data-vj-coeur][data-vj-piece="' + piece + '"]');
    for (var i = 0; i < jumeaux.length; i++) peindre(jumeaux[i], ajoute);

    var dit = bouton.querySelector('[data-vj-coeur-dit]');
    if (dit) dit.textContent = ajoute ? 'Ajouté à mes envies.' : 'Retiré de mes envies.';

    annoncerCompte();

    var grille = document.getElementById('ProductGridContainer');
    if (grille && grille.getAttribute('data-vj-envies-filtre-actif') === '1') filtrer(true);
  });

  /* ── AMORÇAGE, ET REPRISE APRÈS UN REMPLACEMENT DE GRILLE ─────────────── */

  function demarrer() {
    peindreTout(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', function () {
    peindreTout(document);
  });
  /* VJ-CORR-D374 — l'observateur posé ici sur #ProductGridContainer mourait
     au premier changement de page (wdt-filter.js remplace `.product-section`,
     qui le contient). Le signal est émis par vj-carte-carrousel.js depuis le
     parent stable de la grille. */
  window.addEventListener('vj:grille-remplacee', function () {
    peindreTout(document);
  });
  /* Deux onglets ouverts sur la boutique : le cœur coché dans l'un se coche
     dans l'autre. */
  window.addEventListener('storage', function (e) {
    if (e.key === CLE) peindreTout(document);
  });
})();
